/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-display-logos-provalt',
  templateUrl: './display-logos-provalt.component.html',
  styleUrls: ['./display-logos-provalt.component.scss']
})
export class DisplayLogosProvaltComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() oneLine: boolean;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    this.oneLine = false;
  }

  ngOnInit() {
    // This is intentional
  }

}
